import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import MenuItem from './menu-item';
import { getMenuItemListStyles } from '../../../styles/main-menu-styles';

const MenuItemList = ({
  classes,
  items,
  isExpanded,
  onMenuItemClick,
}) => {
  const cnames = classNames(['main-menu-link-list', classes.menuList]);

  return (
    isExpanded &&
    <div className={cnames}>
      {items.map(cfg =>
        (
          <MenuItem
            key={cfg.id}
            node={cfg}
            renderText={cfg.displayName}
            onItemClick={onMenuItemClick}
          />
      ))}
    </div>
  );
};

MenuItemList.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemListStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.number.isRequired,
      PropTypes.string.isRequired,
    ]),
    displayName: PropTypes.string,
    campaignType: PropTypes.oneOf(_.values(CampaignType)).isRequired,
  })).isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

export default withDefaultStyles(MenuItemList, getMenuItemListStyles);
